import {User} from 'firebase/app';

export function isFerlyMember(user: User | null): boolean {
    if (!user) return false;
    return user?.email?.split('@')[1] === 'leika.io' && user?.emailVerified;
}
